// extracted by mini-css-extract-plugin
export default {"page":"MentionsLegalesPage_page__5ChH2","lastUpdate":"MentionsLegalesPage_lastUpdate__4qYxy","section":"MentionsLegalesPage_section__rfe-2"};